import React from "react";
import cvData from "../data/cvData.json";

const AboutMe = () => {
  const { aboutMe, personalInfo } = cvData;

  return (
    <section id="about" className="relative z-10 mx-auto w-full max-w-6xl px-6 py-12">
      <div className="glass-panel glass-sheen p-6 md:p-10">
        <h2 className="section-title">About Me</h2>
        <div className="mt-6 space-y-4 text-left text-base text-text-secondary md:text-lg">
          {aboutMe.map((paragraph, index) => (
            <p key={index} itemProp="description">{paragraph}</p>
          ))}
        </div>
        <div className="mt-8 flex flex-wrap gap-4 text-sm text-text-secondary">
          <div>
            <strong>Name:</strong> <span itemProp="name">{personalInfo.name}</span>
          </div>
          <div>
            <strong>Location:</strong> <span itemProp="addressLocality">{personalInfo.address}</span>
          </div>
          <div>
            <strong>Title:</strong> <span itemProp="jobTitle">{personalInfo.title}</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutMe;
